import {I18n,initializeLanguage,renderControls} from './runtime.js';
import {renderShell} from '../tmp/i18n-build/shell.js';
import {mountToolHelp} from '../observatory/tool-help.js';
import {createDashboardBridge} from '../workspace/dashboard.js';
window.ToolHelp={mount:mountToolHelp};
window.WorkDashboard=createDashboardBridge();
I18n.subscribe(()=>window.WorkDashboard.sync());
initializeLanguage();
// The shell is mounted once before legacy controllers acquire their elements.
// Further renders update Lit text/attribute parts and preserve node identity.
window.LandingIntro?.sync();
window.Homepage?.beforeMount();
document.body.replaceChildren();
I18n.setShell(renderShell);renderShell();renderControls();
window.Homepage?.afterMount();
(async()=>{
 await import('../public/aspect-patterns.js');
 await import('../public/landing-reveal.js');
 await import('../public/hero-charts.js');
 await import('../tmp/i18n-build/legal-content.js');
 await import('../tmp/i18n-build/training-videos-ui.js');
 await import('../tmp/i18n-build/security-ui.js');
 await import('../tmp/i18n-build/people-aaf-ui.js');
 await import('../tmp/i18n-build/app.js');
 const rail = await import('../public/sidebar-rail.js');
 rail.default.mountSidebarRail(document, window);
 await window.AppAuthReady;
 window.Homepage?.appReady();
})().catch(error=>{window.Homepage?.appError();console.error('Application startup failed',error);});
